import { Editor } from '@tinymce/tinymce-react'
import UploadPictures from '../uploadPictures/index.jsx'
import SetColor from '../setColor/index.jsx'
import { useState } from 'react'
import './side.less'
import React from 'react'

export default function NovelIfonSide(props) {
  const [ifon, setIfon] = useState({
    editor: null
  })

  return (<div className='NovelIfonSide'>
    <h3 className='NovelIfonSide_title'>小说头部信息</h3>
    <div className='NovelIfonSide_item'>
      <Editor
        init={{
          height: 400,
          language: 'zh_CN',
          menubar: false,
          branding: false,
          elementpath: false,
          resize: false,
          style_formats_autohide: false,
          plugins: [
            /*  'advlist autolink lists link image charmap print preview anchor',
                         'searchreplace visualblocks code fullscreen',
                         'insertdatetime media table paste code help wordcount', */
          ],
          toolbar_mode: 'wrap',
          toolbar: 'undo redo | fontsizeselect | indent outdent | lineheight  |fontselect  | bold italic backcolor forecolor | \ alignleft aligncenter alignright alignjustify | removeformat | underline \  bullist numlist emoticons',
          max_width: '100%',
          max_height: 450
        }}

        onInit={(content, editor) => {
          setIfon({
            ...ifon,
            editor: editor
          })
        }}
        onEditorChange={(content, editor) => {
          props.ifon.html = content
          props.mySetIfon(props.ifon)
        }}
      />
    </div>
    <div className='NovelIfonSide_item'>
      <span className='item_title'>文本颜色</span>
      <div className='item_mainB'>
        <SetColor color={props.ifon.color} change={(obj) => {
          props.ifon.color = obj.hex
          props.mySetIfon(props.ifon)
        }}></SetColor>
      </div>
    </div>

    <div className='NovelIfonSide_item'>
      {!props.ifon.image.src ? null : <div className='imgBox'>
        <img className='imgBox_img' src={props.ifon.image.src} />
        <i className='imgBox_icon' onClick={() => {
          props.ifon.image = {}
          props.mySetIfon(props.ifon)
        }}></i>
      </div>}
      {props.ifon.image.src ? null : <UploadPictures change={(e) => {
        uploadPictures1(props, e)
      }}></UploadPictures>}

    </div>
  </div>)
}
console.log(React)
function uploadPictures1(props, e) {
  const src = window.URL.createObjectURL(e.file)
  props.ifon.image = {
    fileIfon: e.file,
    src,
    id: Math.random()
  }
  props.mySetIfon(props.ifon)
}
